module.exports = __webpack_public_path__ + "static/media/pefin-assistant-02.c0fdaf0c.png";